import { I18nLocalizedStringMapType } from './types';
import I18nLocaleEnum from './locale.enum';

export function i18nGetInitialLocalizedStringMap(): I18nLocalizedStringMapType {
  return {
    [I18nLocaleEnum.ar]: '',
    [I18nLocaleEnum.en]: '',
  };
}
